import React from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';

import SEO from '~/components/seo';
import ProductForm from '~/components/ProductForm';
import Title from '../../components/Title';

import { Img } from '~/utils/styles';
import { ProductTitle, ProductDescription, Grid } from './styles';

const ProductPage = ({ data }) => {
  const product = data.shopifyProduct;
  return (
    <Container>
      <SEO title={product.title} description={product.description} />
      <Title>{product.title}</Title>
      <ProductContainer>
        <ProductForm product={product} />
        <ProductDescription
          dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
        />
        <Grid>
          {product.images &&
            product.images.map(image => {
              return (
                <Img
                  fluid={image.localFile.childImageSharp.fluid}
                  key={image.id}
                  alt={product.title}
                />
              );
            })}
        </Grid>
      </ProductContainer>
    </Container>
  );
};

export const query = graphql`
  query($handle: String!) {
    shopifyProduct(handle: { eq: $handle }) {
      id
      title
      handle
      productType
      description
      descriptionHtml
      shopifyId
      options {
        id
        name
        values
      }
      variants {
        id
        title
        price
        availableForSale
        shopifyId
        selectedOptions {
          name
          value
        }
      }
      priceRange {
        minVariantPrice {
          amount
          currencyCode
        }
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      images {
        originalSrc
        id
        localFile {
          childImageSharp {
            fluid(maxWidth: 910) {
              ...GatsbyImageSharpFluid_withWebp_tracedSVG
            }
          }
        }
      }
    }
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ProductContainer = styled.div`
  max-width: 1000px;
  margin-top: 40px;
  width: 100%;
  position: relative;
  @media (max-width: 1048px) {
    padding: 24px;
    margin-top: 0;
  }
`;

export default ProductPage;
